/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_Qr_ConfirmedInputs */

const vi_payment_qr_confirmed = /** @type {(inputs: Payment_Qr_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thanh toán thành công!`)
};

/**

* @param {Payment_Qr_ConfirmedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const payment_qr_confirmed = /** @type {((inputs?: Payment_Qr_ConfirmedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Qr_ConfirmedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_payment_qr_confirmed(inputs)
});